// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uC_g4JnAE8k_AE_ayyIQ{grid-template-rows:114px 1fr;height:100%;display:grid}.E6vjEcLcMMgU5n4PgPlG{grid-template-columns:330px auto max-content;grid-auto-flow:column;height:100%;display:grid;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `uC_g4JnAE8k_AE_ayyIQ`,
	"container": `E6vjEcLcMMgU5n4PgPlG`
};
export default ___CSS_LOADER_EXPORT___;
